import { User } from '@typing/global';

const storagePrefix = 'inbound_outbound_';

const storage = {
  getToken: () => {
    const tokenStr = window.sessionStorage.getItem(`${storagePrefix}token`);
    if (!tokenStr) return null;
    try {
      return JSON.parse(tokenStr);
    } catch {
      return null;
    }
  },
  setToken: (token: string) => {
    window.sessionStorage.setItem(`${storagePrefix}token`, JSON.stringify(token));
  },
  clearToken: () => {
    window.sessionStorage.removeItem(`${storagePrefix}token`);
    window.sessionStorage.removeItem(`${storagePrefix}token`);
  },
  getUser: () => {
    const userStr = window.sessionStorage.getItem(`${storagePrefix}user`);
    if (!userStr) return null;
    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  },
  setUser: (user: User) => {
    window.sessionStorage.setItem(`${storagePrefix}user`, JSON.stringify(user));
  },
  clearUser: () => {
    window.sessionStorage.removeItem(`${storagePrefix}user`);
  },
  getChatRoomId: () => {
    const chatRoomIdStr = window.sessionStorage.getItem(`${storagePrefix}chatRoomId`);
    if (!chatRoomIdStr) return null;
    try {
      return JSON.parse(chatRoomIdStr);
    } catch {
      return null;
    }
  },
  setChatRoomId: (chatRoomId: number) => {
    window.sessionStorage.setItem(`${storagePrefix}chatRoomId`, JSON.stringify(chatRoomId));
  },
  clearChatRoomId: () => {
    window.sessionStorage.removeItem(`${storagePrefix}chatRoomId`);
  },
};

export default storage;
